/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ExternalUserDetailResponse,
    ExternalUserDetailResponseFromJSON,
    ExternalUserDetailResponseToJSON,
} from '../models/ExternalUserDetailResponse';
import {
    type ExternalUserResponsePagedResult,
    ExternalUserResponsePagedResultFromJSON,
    ExternalUserResponsePagedResultToJSON,
} from '../models/ExternalUserResponsePagedResult';
import {
    type ExternalUserSearchRequest,
    ExternalUserSearchRequestFromJSON,
    ExternalUserSearchRequestToJSON,
} from '../models/ExternalUserSearchRequest';
import {
    type ExternalUserStatus,
    ExternalUserStatusFromJSON,
    ExternalUserStatusToJSON,
} from '../models/ExternalUserStatus';
import {
    type ExternalUserStatusUpdateRequest,
    ExternalUserStatusUpdateRequestFromJSON,
    ExternalUserStatusUpdateRequestToJSON,
} from '../models/ExternalUserStatusUpdateRequest';
import {
    type ExternalUserStatusUpdateResponse,
    ExternalUserStatusUpdateResponseFromJSON,
    ExternalUserStatusUpdateResponseToJSON,
} from '../models/ExternalUserStatusUpdateResponse';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';

export interface ApiExternalUsersSearchesPostRequest {
    externalUserSearchRequest: ExternalUserSearchRequest;
}

export interface ApiExternalUsersUserIdGetRequest {
    userId: string;
}

export interface ApiExternalUsersUserIdStatusPutRequest {
    userId: string;
    externalUserStatusUpdateRequest: ExternalUserStatusUpdateRequest;
}

/**
 * 
 */
export class ExternalUsersApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiExternalUsersSearchesPost without sending the request
     */
    async apiExternalUsersSearchesPostRequestOpts(requestParameters: ApiExternalUsersSearchesPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['externalUserSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'externalUserSearchRequest',
                'Required parameter "externalUserSearchRequest" was null or undefined when calling apiExternalUsersSearchesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/external-users/searches`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExternalUserSearchRequestToJSON(requestParameters['externalUserSearchRequest']),
        };
    }

    /**
     */
    async apiExternalUsersSearchesPostRaw(requestParameters: ApiExternalUsersSearchesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalUserResponsePagedResult>> {
        const requestOptions = await this.apiExternalUsersSearchesPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalUserResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiExternalUsersSearchesPost(requestParameters: ApiExternalUsersSearchesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalUserResponsePagedResult> {
        const response = await this.apiExternalUsersSearchesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiExternalUsersStatusesGet without sending the request
     */
    async apiExternalUsersStatusesGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/external-users/statuses`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiExternalUsersStatusesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExternalUserStatus>>> {
        const requestOptions = await this.apiExternalUsersStatusesGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExternalUserStatusFromJSON));
    }

    /**
     */
    async apiExternalUsersStatusesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExternalUserStatus>> {
        const response = await this.apiExternalUsersStatusesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiExternalUsersUserIdGet without sending the request
     */
    async apiExternalUsersUserIdGetRequestOpts(requestParameters: ApiExternalUsersUserIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiExternalUsersUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/external-users/{userId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiExternalUsersUserIdGetRaw(requestParameters: ApiExternalUsersUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalUserDetailResponse>> {
        const requestOptions = await this.apiExternalUsersUserIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalUserDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiExternalUsersUserIdGet(requestParameters: ApiExternalUsersUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalUserDetailResponse> {
        const response = await this.apiExternalUsersUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiExternalUsersUserIdStatusPut without sending the request
     */
    async apiExternalUsersUserIdStatusPutRequestOpts(requestParameters: ApiExternalUsersUserIdStatusPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiExternalUsersUserIdStatusPut().'
            );
        }

        if (requestParameters['externalUserStatusUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'externalUserStatusUpdateRequest',
                'Required parameter "externalUserStatusUpdateRequest" was null or undefined when calling apiExternalUsersUserIdStatusPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/external-users/{userId}/status`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ExternalUserStatusUpdateRequestToJSON(requestParameters['externalUserStatusUpdateRequest']),
        };
    }

    /**
     */
    async apiExternalUsersUserIdStatusPutRaw(requestParameters: ApiExternalUsersUserIdStatusPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalUserStatusUpdateResponse>> {
        const requestOptions = await this.apiExternalUsersUserIdStatusPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalUserStatusUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiExternalUsersUserIdStatusPut(requestParameters: ApiExternalUsersUserIdStatusPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalUserStatusUpdateResponse> {
        const response = await this.apiExternalUsersUserIdStatusPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
